import { render, staticRenderFns } from "./UserPassword.vue?vue&type=template&id=4a44d865&scoped=true"
import script from "./UserPassword.vue?vue&type=script&lang=js"
export * from "./UserPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44d865",
  null
  
)

export default component.exports